"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.58 4.4a1.3 1.3 0 0 0-1.3 1.3v9.49l.325-.168a1.7 1.7 0 0 1 1.565 0l1.024.531 1.024-.53a1.7 1.7 0 0 1 1.565-.001l1.024.53 1.023-.53a1.7 1.7 0 0 1 1.566 0l.324.168V5.7a1.3 1.3 0 0 0-1.3-1.3zm-2.7 1.3A2.7 2.7 0 0 1 6.58 3h6.84a2.7 2.7 0 0 1 2.7 2.7v10.073c0 .746-.786 1.311-1.512.936h-.001l-.856-.445a.3.3 0 0 0-.276 0l-1.195.62h-.002a1.03 1.03 0 0 1-.943 0h-.002l-1.195-.62a.3.3 0 0 0-.276.001l-1.194.62h-.002a1.03 1.03 0 0 1-.944 0H7.72l-1.194-.62a.3.3 0 0 0-.277 0l-.855.444-.003.001c-.725.373-1.51-.191-1.51-.937z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.306 6.082a.7.7 0 0 1 .7.7v.002c.379.107.683.304.91.561.331.377.445.826.445 1.155a.7.7 0 1 1-1.4 0 .4.4 0 0 0-.096-.23c-.054-.061-.191-.178-.559-.178-.308 0-.468.09-.543.16a.33.33 0 0 0-.111.248c0 .056.007.11.117.213.138.13.388.283.825.48.45.202.883.42 1.2.707.357.326.567.74.567 1.26 0 .55-.241 1.026-.642 1.35-.21.168-.452.289-.713.364v.005a.7.7 0 1 1-1.4 0v-.015c-.855-.274-1.354-1.028-1.354-1.703a.7.7 0 1 1 1.4 0c0 .004.003.03.022.072.02.046.056.099.107.149.095.093.257.187.525.187s.442-.075.534-.149a.31.31 0 0 0 .121-.26c0-.09-.016-.139-.11-.224-.134-.122-.38-.264-.832-.467-.467-.21-.893-.44-1.207-.734-.342-.32-.56-.728-.56-1.235 0-.471.19-.937.565-1.28a1.95 1.95 0 0 1 .79-.434v-.004a.7.7 0 0 1 .7-.7m2.687 1.378a.7.7 0 0 1 .7-.7h1.355a.7.7 0 1 1 0 1.4h-1.355a.7.7 0 0 1-.7-.7m0 2.37a.7.7 0 0 1 .7-.7h1.355a.7.7 0 1 1 0 1.4h-1.355a.7.7 0 0 1-.7-.7m0 2.372a.7.7 0 0 1 .7-.7h1.355a.7.7 0 1 1 0 1.4h-1.355a.7.7 0 0 1-.7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ReceiptIcon20.js.map